// import faker from "faker";
import {randomColor} from "./utils";

export default function makeData(datos,tipo) {
  let options = [
    {label: 'bike', backgroundColor: '#B0FC38'},
    {label: 'van', backgroundColor: '#9A7B4F'}
  ];
  let optionss = [
    {label: 'pickup', backgroundColor: '#fc0127'},
    {label: 'shipment', backgroundColor: '#f4a020'},
    {label: 'delivery', backgroundColor: '#B0FC38'}
  ];
  // console.log(datos,'datos')
  // let dataTable = [];
  // for (let i = 0; i < datos.length; i++) {
  //   let row = {
  //     transptype_id: parseInt(datos[i].transptype_id),
  //     transptype_name:String(datos[i].transptype_name), 
  //     transptype_routing:String(datos[i].transptype_routing), 
  //     transptype_capacityitems:parseInt(datos[i].transptype_capacityitems), 
  //     transptype_capacityweight:parseFloat(datos[i].transptype_capacityweight), 
  //     transptype_speed:parseFloat(datos[i].transptype_speed), 
  //     transptype_fixcost:parseFloat(datos[i].transptype_fixcost), 
  //     transptype_kmcost:parseFloat(datos[i].transptype_kmcost), 
  //     transptype_hourcost:parseFloat(datos[i].transptype_hourcost), 
  //     transptype_co2emissions:parseFloat(datos[i].transptype_co2emissions )
  //   }; 
  //   // options.push({label: row.music, backgroundColor: randomColor()});

  //   dataTable.push(row);
  // }
  let columns
  (tipo==='vehicle')
  ?columns = [
    {
      id: "transptype_id",
      label: "Id",
      accessor: "transptype_id",
      width: 20,
      dataType: "number",
      options: []
    },
    {
      id: "transptype_name",
      label: "Name",
      accessor: "transptype_name",
      width: 150,
      dataType: "text",
      options: []
    },
    {
      id: "transptype_routing",
      label: "Type",
      accessor: "transptype_routing",
      width: 100,
      dataType: "select",
      options: options
    },
    {
      id: "transptype_capacityitems",
      label: "Capacity Items",
      accessor: "transptype_capacityitems",
      width: 100,
      dataType: "number",
      options: []
    },
    {
      id: "transptype_capacityweight",
      label: "Capacity Weight",
      accessor: "transptype_capacityweight",
      dataType: "number",
      width: 120,
      options: []
    },
    {
      id: "transptype_speed",
      label: "Speed",
      accessor: "transptype_speed",
      dataType: "number",
      width: 100,
      options: []
    },
    {
      id: "transptype_fixcost",
      label: "Fix Cost",
      accessor: "transptype_fixcost",
      dataType: "number",
      width: 100,
      options: []
    },
    {
      id: "transptype_kmcost",
      label: "km Cost",
      accessor: "transptype_kmcost",
      dataType: "number",
      width: 100,
      options: []
    },
    {
      id: "transptype_hourcost",
      label: "Hour Cost",
      accessor: "transptype_hourcost",
      dataType: "number",
      width: 100,
      options: []
    },
    {
      id: "transptype_co2emissions",
      label: "CO2 Emissions",
      accessor: "transptype_co2emissions",
      dataType: "number",
      width: 100,
      options: []
    },
    									
  ]
  :(tipo==='hubs')							
    ?columns=[
        {
          id: "hub_id",
          label: "Id",
          accessor: "hub_id",
          width: 20,
          dataType: "number",
          options: []
        },
        {
          id: "hub_name",
          label: "Name",
          accessor: "hub_name",
          width: 100,
          dataType: "text",
          options: []
        },
        {
          id: "hub_lat",
          label: "Latitude",
          accessor: "hub_lat",
          width: 100,
          dataType: "number",
          options: []
        },
        {
          id: "hub_lon",
          label: "Longitude",
          accessor: "hub_lon",
          width: 100,
          dataType: "number",
          options: []
        },
        {
          id: "hub_pc",
          label: "Postal Code",
          accessor: "hub_pc",
          width: 100,
          dataType: "number",
          options: []
        },
        {
          id: "hub_earlytime",
          label: "Early Time",
          accessor: "hub_earlytime",
          width: 100,
          dataType: "number",
          options: []
        },
        {
          id: "hub_latetime",
          label: "Late Time",
          accessor: "hub_latetime",
          width: 100,
          dataType: "number",
          options: []
        },
        {
          id: "hub_monthlypayment",
          label: "Monthly Payment",
          accessor: "hub_monthlypayment",
          width: 150,
          dataType: "number",
          options: []
        },
      ]
    :(tipo==='orders')
      ?columns=[
          {
            id: "order_id",
            label: "Id",
            accessor: "order_id",
            width: 20,
            dataType: "number",
            options: []
          },
          {
            id: "order_name",
            label: "Name",
            accessor: "order_name",
            width: 100,
            dataType: "text",
            options: []
          },
          {
            id: "order_mode",
            label: "Mode",
            accessor: "order_mode",
            width: 100,
            dataType: "select",
            options: optionss
          },
          {
            id: "order_idhub",
            label: "Hub id",
            accessor: "order_idhub",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_lat1",
            label: "Latitude 1",
            accessor: "order_lat1",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_lon1",
            label: "Longitude 1",
            accessor: "order_lon1",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_earlytime1",
            label: "Early Time 1",
            accessor: "order_earlytime1",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_latetime1",
            label: "Late Time 1",
            accessor: "order_latetime1",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_servicetime1",
            label: "Service Time 1",
            accessor: "order_servicetime1",
            width: 120,
            dataType: "number",
            options: []
          },									
          {
            id: "order_items",
            label: "Items",
            accessor: "order_items",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_weight",
            label: "Weight",
            accessor: "order_weight",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_pc",
            label: "Postal Code",
            accessor: "order_pc",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_lat2",
            label: "Latitude 2",
            accessor: "order_lat2",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_lon2",
            label: "Longitude",
            accessor: "order_lon2",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_earlytime2",
            label: "Early Time 2",
            accessor: "order_earlytime2",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_latetime2",
            label: "Late Time 2",
            accessor: "order_latetime2",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_servicetime2",
            label: "Service Time 2",
            accessor: "order_servicetime2",
            width: 120,
            dataType: "number",
            options: []
          },
          {
            id: "order_bolactivo",
            label: "Active",
            accessor: "order_bolactivo",
            width: 100,
            dataType: "number",
            options: []
          },
          {
            id: "order_revenue",
            label: "Revenue",
            accessor: "order_revenue",
            width: 100,
            dataType: "number",
            options: []
          },
        ]
      :(tipo==='match')
        ?columns=[
            {
              id: "transp_id",
              label: "Id",
              accessor: "transp_id",
              width: 20,
              dataType: "number",
              options: []
            },
            {
              id: "transp_idtransptype",
              label: "Id Vehicle",
              accessor: "transp_idtransptype",
              width: 70,
              dataType: "number",
              options: []
            },
            {
              id: "transp_vehicle_name",
              label: "Vehicle Name",
              accessor: "transp_vehicle_name",
              width: 70,
              dataType: "text",
              options: []
            },
            {
              id: "transp_idhub",
              label: "Id Hub",
              accessor: "transp_idhub",
              width: 50,
              dataType: "number",
              options: []
            },
            {
              id: "transp_hub_name",
              label: "Hub Name",
              accessor: "transp_hub_name",
              width: 50,
              dataType: "text",
              options: []
            },
            {
              id: "transp_num",
              label: "Number vehicles",
              accessor: "transp_num",
              width: 70,
              dataType: "number",
              options: []
            },
        ]:(tipo==='route')
        ?columns=[
            {
              id: "order_id",
              label: "Order Id",
              accessor: "order_id",
              width: 50,
              dataType: "number",
              options: []
            },
            {
              id: "order_position",
              label: "Tour Position",
              accessor: "order_position",
              width: 60,
              dataType: "number",
              options: []
            },
            {
              id: "order_idtour",
              label: "Tour Id",
              accessor: "order_idtour",
              width: 50,
              dataType: "number",
              options: []
            },
        ]
        :(tipo==='route_data')
        ?columns=[
            {
              id: "id_tour",
              label: "Id Tour",
              accessor: "id_tour",
              width: 50,
              dataType: "number",
              options: []
            },
            {
              id: "veh_id",
              label: "Id Vehicle",
              accessor: "veh_id",
              width: 50,
              dataType: "number",
              options: []
            },
            {
              id: "hora_init",
              label: "Initial Time",
              accessor: "hora_init",
              width: 50,
              dataType: "text",
              options: []
            },
            {
              id: "duration_time",
              label: "Duration (min)",
              accessor: "duration_time",
              width: 50,
              dataType: "number",
              options: []
            },
        ]:columns={}

  // console.log(columns,'columns')
  return {columns: columns, data: datos, skipReset: false};
}

// export default function makeData(count) {
//   let data = [];
//   let options = [];
//   for (let i = 0; i < count; i++) {
//     let row = {
//       ID: faker.mersenne.rand(),
//       firstName: faker.name.firstName(),
//       lastName: faker.name.lastName(),
//       email: faker.internet.email(),
//       age: Math.floor(20 + Math.random() * 20),
//       music: faker.music.genre()
//     };
//     options.push({label: row.music, backgroundColor: randomColor()});

//     data.push(row);
//   }

//   let columns = [
//     {
//       id: "firstName",
//       label: "First Name",
//       accessor: "firstName",
//       minWidth: 100,
//       dataType: "text",
//       options: []
//     },
//     {
//       id: "lastName",
//       label: "Last Name",
//       accessor: "lastName",
//       minWidth: 100,
//       dataType: "text",
//       options: []
//     },
//     {
//       id: "age",
//       label: "Age",
//       accessor: "age",
//       width: 80,
//       dataType: "number",
//       options: []
//     },
//     {
//       id: "email",
//       label: "E-Mail",
//       accessor: "email",
//       width: 300,
//       dataType: "text",
//       options: []
//     },
//     {
//       id: "music",
//       label: "Music Preference",
//       accessor: "music",
//       dataType: "select",
//       width: 200,
//       options: options
//     },
//     {
//       id: 999999,
//       width: 20,
//       label: "+",
//       disableResizing: true,
//       dataType: "null"
//     }
//   ];
//   return {columns: columns, data: data, skipReset: false};
// }
